var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['rapor-ozet-karti', _vm.vurgulu ? 'roz--vurgu' : '']},[_c('div',{staticClass:"roz-baslik"},[_vm._v(_vm._s(_vm.baslik))]),_c('div',{class:['roz-deger', _vm.renkSinifi]},[_vm._v(_vm._s(_vm.deger))])])
}
var staticRenderFns = []

export { render, staticRenderFns }